import { useState } from 'react'
import ReactDOM from 'react-dom'
import styles from './image.module.css'

const Image = ({ zoom, ...rest }) => {
  const [click, setClick] = useState(false)

  const setFlag = () => {
    setClick(true)
  }

  const unsetFlag = () => {
    setClick(false)
  }

  if (!zoom) return <img {...rest} />

  return (
    <>
      <img {...rest} onClick={setFlag} className={`${styles.zoomable}`}/> {/* This stays always */}
      
      {click && ReactDOM.createPortal(
        <div onClick={unsetFlag} className={`${styles.lightbox} ${styles.show}`}>
          <img {...rest} className={styles.show_image} />
        </div>,
        document.body
      )}
    </>
  )
}

export default Image
